<template>
	<div>
		<h2>Estadias Anteriores</h2>
		<br /><br />
		<h4 class="filter_sentence">Selecione abaixo os seus filtros.</h4>
		<br />

		<form>
			<div class="main_content">
				<div class="filter_form">
					<div class="element">
						<div class="class_header">
							<h3>Escolha uma Data</h3>
						</div>

						<datepicker></datepicker>
					</div>
						
					<div class="element">
						<div class="class_header">
							<h3>Escolha um Hotel</h3>
						</div>

						<HotelDropdown></HotelDropdown>
					</div>

					<div class="element">
						<div class="class_header">
							<h3>Número da Reserva</h3>
						</div>

						<div class="centerx default-input">
						  <vs-input class="inputx" placeholder="Insira o número da reserva" v-model="value1"/>
						</div>
					</div>

					<div class="element_button">
						<div class="see_all_button">
							<vs-button color="#63C0BB" size="large" type="filled">Consultar Todas</vs-button>
						</div>
					</div>

				</div>

				<div class="past_reservations_table">
					<vs-table search stripe :data="past_reservations">
					  <template slot="header">
						<h3>
							{{ $t('SuasEstadiasAnteriores') }} 
						</h3>
					  <br />
					  </template>
					  <template slot="thead">
						<vs-th sort-key="numeroReserva">
							Número da Reserva
						</vs-th>
						<vs-th sort-key="hotel">
						    Hotel
						</vs-th>
						<vs-th sort-key="EstadoReserva">
							Estado da Reserva
						</vs-th>
						<vs-th sort-key="dataCheckin">
							Data de Check In
						</vs-th>
						<vs-th sort-key="noites">
						    Noites
						</vs-th>
						<vs-th sort-key="Total">
							Total
						</vs-th>
						<vs-th sort-key="Fatura">
						    Fatura
						</vs-th>
					  </template>

					  <template slot-scope="{data}">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
							<vs-td :data="data[indextr].numeroReserva">
								{{data[indextr].numeroReserva}}
						    </vs-td>

							<vs-td :data="data[indextr].hotel">
								{{data[indextr].hotel}}
						    </vs-td>

							<vs-td :data="data[indextr].EstadoReserva">
								{{data[indextr].EstadoReserva}}
						    </vs-td>

							<vs-td :data="data[indextr].dataCheckin">
								{{data[indextr].dataCheckin}}
						    </vs-td>
						  
							<vs-td :data="data[indextr].noites">
								{{data[indextr].noites}}
						    </vs-td>

							<vs-td :data="data[indextr].Total">
								{{data[indextr].Total}}
						    </vs-td>
						  
							<vs-td :data="data[indextr].Fatura">
								{{data[indextr].Fatura}}
						    </vs-td>

						</vs-tr>
					  </template>
					</vs-table>

			    </div>
			</div>
		</form>

	</div>
</template>

<script>
import Datepicker from '@/views/components/Datepicker.vue'
import HotelDropdown from '@/views/components/HotelDropdown.vue'

export default {
	data(){
	  return {
		value1: "",
		past_reservations:[
			{
				"numeroReserva": 3824981,
				"hotel": "Albacora",
				"EstadoReserva": "Checked Out",
				"dataCheckin": "17-10-2018",
				"noites": 1,
				"Total": "38.01",
				"Fatura": "FT508931/508931",
			},
			{
				"numeroReserva": 3812387,
				"hotel": "Lagos",
				"EstadoReserva": "Checked Out",
				"dataCheckin": "23-10-2019",
				"noites": 7,
				"Total": "1038.01",
				"Fatura": "FT508956/508956",
			},
			{
				"numeroReserva": 5378904,
				"hotel": "Collection Douro",
				"EstadoReserva": "Checked Out",
				"dataCheckin": "09-11-2016",
				"noites": 2,
				"Total": "908.01",
				"Fatura": "FT508231/508231",
			},
			{
				"numeroReserva": 5378345,
				"hotel": "Albacora",
				"EstadoReserva": "Checked Out",
				"dataCheckin": "17-10-2018",
				"noites": 7,
				"Total": "1938.01",
				"Fatura": "FT508956/508956",
			},
			{
				"numeroReserva": 1278345,
				"hotel": "Collection Braga",
				"EstadoReserva": "Checked Out",
				"dataCheckin": "02-02-2018",
				"noites": 6,
				"Total": "1238.01",
				"Fatura": "FT567931/567931 ",
			},
			{
				"numeroReserva": 8769870,
				"hotel": "Collection Elvas",
				"EstadoReserva": "Checked Out",
				"dataCheckin": "07-10-2019",
				"noites": 7,
				"Total": "1024.37",
				"Fatura": "FT508956/508956",
			},
		],			  
	  }
	},
    components: {
		Datepicker,
		HotelDropdown,
    }
}
</script>

<style>

	.filter_form {
		display: flex;
	}

	.class_header {
		margin-bottom: 25px;
	}

	.element {
		margin-right: 75px;
	}

	.element_button {
		margin-right: 25px;
		margin-top: 25px;
	}

	.past_reservations_table {
		margin-top: 25px;
	}

	/* Mobile view */
	@media (max-width: 768px) {
		
		.filter_form {
			display: none;
		}

		.filter_sentence {
			display: none;
		}

	}

</style>
